import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let promptExample = `read -rp "Username: " username
read -rsp "Password: " password   # -s: silent (no echo)
echo
read -ra tags -p "Tags (space separated): "   # -a: into an array

echo "user=$username tags=$\{tags[0]}"`

let fileLoopExample = `while IFS= read -r line; do
    echo "Processing: $line"
done < input.txt

# Reading a CSV: split fields on IFS
while IFS=, read -r name role; do
    echo "$name works as $role"
done < staff.csv`

let mapfileExample = `mapfile -t lines < input.txt
echo "Total lines: $\{#lines[@]}"
echo "First line: $\{lines[0]}"`

export default function ReadingInput() {
    return (
        <div className={globalStyles.article}>
            <h1>Reading input</h1>

            <h3>Prompting a user</h3>
            <SyntaxHighlighter
                children={promptExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '350px'}}>
                    <thead>
                    <tr>
                        <th>Flag</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>-r</code></td>
                        <td>Raw mode — don't let backslashes escape characters (almost always what you want)</td>
                    </tr>
                    <tr>
                        <td><code>-p</code></td>
                        <td>Show a prompt before reading</td>
                    </tr>
                    <tr>
                        <td><code>-s</code></td>
                        <td>Silent — don't echo typed characters (for passwords)</td>
                    </tr>
                    <tr>
                        <td><code>-a</code></td>
                        <td>Read words into an array</td>
                    </tr>
                    <tr>
                        <td><code>-n N</code></td>
                        <td>Read exactly N characters and return</td>
                    </tr>
                    <tr>
                        <td><code>-t N</code></td>
                        <td>Time out after N seconds</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Reading a file line by line</h3>
            <p>Setting <code>IFS=</code> for the loop stops <code>read</code> from trimming leading/trailing
                whitespace from each line.</p>
            <SyntaxHighlighter
                children={fileLoopExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Slurping a whole file into an array</h3>
            <SyntaxHighlighter
                children={mapfileExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
